import React from "react";
import { Spinner } from "react-bootstrap";
const BackDropLoader = ({ loader }) => {
  return (
    <div className="backdrop-loader">
      {loader ? (
        loader
      ) : (
        <Spinner animation="border" variant="light" size="lg" />
      )}
    </div>
  );
};

export default BackDropLoader;
